/* eslint-disable */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // If returning from Emergent Google OAuth, AuthCallback (Login page) will
    // handle session_id exchange. Skip the /me check to avoid a race condition.
    if (typeof window !== 'undefined' && window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem('elaraa_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi.me()
      .then((u) => setUser(u))
      .catch(() => {
        localStorage.removeItem('elaraa_token');
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await authApi.login({ email, password });
    localStorage.setItem('elaraa_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, name) => {
    const data = await authApi.register({ email, password, name });
    localStorage.setItem('elaraa_token', data.token);
    setUser(data.user);
    return data.user;
  };

  // Emergent-managed Google OAuth: exchange session_id from URL hash for JWT.
  const loginWithGoogleSession = async (session_id) => {
    const data = await authApi.googleSession(session_id);
    localStorage.setItem('elaraa_token', data.token);
    setUser(data.user);
    return data.user;
  };

  // Firebase Phone OTP: exchange verified Firebase ID token for our JWT.
  const loginWithPhone = async (id_token, name) => {
    const data = await authApi.phoneLogin({ id_token, name });
    localStorage.setItem('elaraa_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('elaraa_token');
    setUser(null);
  };

  const updateProfile = async (data) => {
    const updated = await authApi.updateProfile(data);
    setUser(updated);
    return updated;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, loginWithGoogleSession, loginWithPhone, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
